import { OnInit, Directive, inject } from '@angular/core'
import { IconComponent, IconSize } from './icon.component'


@Directive({
  selector: '[icon-small]',
  standalone: false,
})
export class IconSmallDirective implements OnInit {
  private _icon = inject(IconComponent)
  ngOnInit(): void {
    this._icon.size.set(IconSize.Small)
  }
}

@Directive({
  selector: '[icon-medium]',
  standalone: false,
})
export class IconMediumDirective implements OnInit {
  private _icon = inject(IconComponent)
  ngOnInit(): void {
    this._icon.size.set(IconSize.Medium)
  }
}

@Directive({
  selector: '[icon-large]',
  standalone: false,
})
export class IconLargeDirective implements OnInit {
  private _icon = inject(IconComponent)
  ngOnInit(): void {
    this._icon.size.set(IconSize.Large)
  }
}

@Directive({
  selector: '[icon-xlarge]',
  standalone: false,
})
export class IconXLargeDirective implements OnInit {
  private _icon = inject(IconComponent)
  ngOnInit(): void {
    this._icon.size.set(IconSize.XLarge)
  }
}
